<template>
  <b-container>
    <shipping-list :type="type" />
  </b-container>
</template>
<script>
  import ShippingList from '@/components/ShippingList'

  export default {
    name: 'ListingPage',
    components: {
      ShippingList
    },
    props: {
      type: {
        type: String,
        default: 'ongoing'
      }
    }
  }
</script>
